// -------- Banner Notification Configuration List ------------
export const NOTIFICATION_MESSAGES = {
  ERROR_TITLE: "Error",
  ROI_EDIT_FAIL_SUBTITLE:
    "Failed to edit application settings, the camera or ROI which triggered this event is not available or deleted. Please check other events.",
  SNAPSHOT_FAIL_SUBTITLE: "Failed to refresh the snapshot. Please try again later",
  ALERT_CREATE_FAIL_SUBTITLE: "Failed to create alert.Please try again later.",
  ALERT_UPDATE_FAIL_SUBTITLE: "Failed to update alert.Please try again later.",
  ALERT_DELETE_FAIL_SUBTITLE: "Failed to delete alert.Please try again later.",
  CALIBRATION_FAIL_SUBTITLE: "Failed to create manual calibration.Please try again later.",
  EVENT_FETCH_FAIL_SUBTITLE: "Failed to fetch event. Please try again later.",
  CAMERA_UPDATE_FAIL_SUBTITLE: "Failed to update camera. Please try again later or Proceed to change camera Location.",
  SUSPEND_LICENSE_FAIL_SUBTITLE: "Failed to suspend license. Please try again later.",
  RESUME_LICENSE_FAIL_SUBTITLE: "Failed to resume license. Please try again later.",
  NO_LICENSE_AVAILABLE: "You’ve exceeded your license limit for this type, please buy more licenses of the given type to resume the license.",
  LICENSE_LIMIT_EXCEEDED: "License limit exceeded",
  CHANGE_LICENSE_FAILED: "Failed to change license. Please try again later.",
  FETCH_NOTIFICATION_GROUPS_FAIL_SUBTITLE: "Failed to fetch notification groups. Please try again later.",
  NO_NOTIFICATION_GROUPS_AVAILABLE: "No notification groups available.",
  FAILED_TO_FETCH: "Failed to fetch",
  AREA_NAME_EMPTY_SUBTITLE: "Area name cannot be empty. Please provide a name for all areas before proceeding.",
  SUBAREA_NAME_EMPTY_SUBTITLE: "Subarea name cannot be empty. Please provide a name for all subareas before proceeding.",
  USERS_LOAD_FAIL_SUBTITLE: "Failed to load users. Please try again later.",
  REFETCH_SNAPSHOT_FAIL_SUBTITLE: "Failed to refetch the snapshot",
  CAMPUS_UPDATE_SUCCESS: "Campus details updated successfully",
  SEARCH_CREATE_FAIL_SUBTITLE: "Failed to create search. Please try again.",
  ENABLE_SEARCH_FAIL_SUBTITLE: "We could not enable the search on this camera stream due to an unexpected error. Please try again.",
  DISABLE_SEARCH_FAIL_SUBTITLE: "We could not disable the search on this camera stream due to an unexpected error. Please try again.",
  RESUME_SEARCH_FAIL_SUBTITLE: "We could not resume the search on this camera stream due to an unexpected error. Please try again.",
  SEARCH_IMAGE_FETCH_FAIL_SUBTITLE: "Failed to fetch search result images. Please try again.",
  HS_NO_LICENSE_SUBTITLE:
    "Search license unavailable. Contact your administrator to purchase a license and start searching.",
  HS_LICENSE_NOT_APPLIED_SUBTITLE:
    "No licensed streams found. Assign a license to your target camera stream on the license page to start searching."
};

export const notificationTypes = {
  0: "Camera Offline",
  1: "Companion Offline",
  2: "Camera Capacity Limit",
  3: "App Capacity Limit",
  4: "Stream Compression",
  5: "Duplicate UUID",
  6: "App Availability",
  7: "No Permission",
  8: "Evidence deletion",
  9: "Live Feed pop-up",
  10: "License expiration",
  11: "License overuse",
  12: "License Capacity Limit",
  13: "Complete User Onboarding",
  14: "User Notification Groups",
  15: "User Notification Groups",
  16: "Event Alert",
  17: "Event Alerts",
  18: "User(s) added to group",
  19: "User deleted from group",
  20: "User group renamed",
  21: "Delete User",
  22: "Delete Usergroup",
  23: "User details updated",
  24: "User group added",
  25: "Invite sent",
  26: "Download Image Fail",
  27: "ROI Delete",
  28: "Failed to unpair camera",
  29: "Event resolved",
  30: "Calibration in progress",
  31: "Camera pairing",
  32: "Delete Camera",
  33: "Delete Site",
  34: "No Permission to delete site",
  35: "Document download failed",
  36: "Event not resolved",
  37: "Snapshot Fail",
  38: "Campus deleted successfully",
  39: "Campus added successfully",
  40: "Site added successfully",
  41: "No Permission to delete campus",
  42: "Image upload success",
  43: "Image upload fail",
  44: "No permission to view live feed",
  45: "Alert created",
  46: "Alert updated",
  47: "Alert deleted",
  48: "Camera access credential error",
  49: "ROI Create Fail",
  50: "License type change success",
  51: "License type change failed",
  52: "Something went wrong",
  53: "Site updated successfully",
  54: "Campus updated successfully",
  55: "Alert Fail",
  56: "Update Alert Fail",
  57: "Alert Delete Fail",
  58: "Calibration Fail",
  59: "Role update success",
  60: "Success",
  61: "Failed",
  62: "Processing event video and snapshot",
  63: "Event video failed",
  64: "Processing event video",
  65: "max amount of streams",
  66: "Information",
  67: "Access Credentials update",
  68: "Companion Devices Edit Details",
  69: "Companion Devices Evidence Status Updated",
  70: "ROI Update Fail",
  71: "Undeploy CV App",
  72: "Undeploy failed",
  73: "No ROIs",
  74: "Calibration after camera onboarding",
  75: "Failed to Calibrate",
  76: "Events resolved",
  77: "Fetch Events Fail",
  78: "Updated credentials",
  79: "Updated Camera",
  80: "Updated camera fail",
  81: "Account cancelled",
  82: "CCD firmware update",
  83: "Resend Invite",
  84: "Invite not deleted",
  85: "Delete invite",
  86: "Updated invite sent",
  87: "ROI Edit Fail",
  88: "User details not updated",
  89: "Stream calibration in progress",
  90: "Suspend License failed",
  91: "Resume License failed",
  92: "No available License",
  93: "Change License Failed",
  94: "Assign License Successful",
  95: "Assign License Failed",
  96: "Failed to fetch",
  97: "Image Deleted Successfully",
  98: "Enrolled Appearance Failed to Delete",
  99: "Appearance deployed successfully",
  100: "CCD Offline",
  101: "Floor delete success",
  102: "Floor delete error",
  103: "Area name cannot be empty",
  104: "Subarea name cannot be empty",
  105: "Invite failed",
  106: "Edit site name failed",
  107: "Edit site city failed",
  108: "Edit site description failed",
  109: "Edit site failed",
  110: "Users Load Fail",
  111: "Refetch Snapshot Fail",
  112: "Appearance Image Deleted",
  113: "Appearance Image Delete Failed",
  114: "Appearance Image Upload Failed",
  115: "Create Appearance Failed",
  116: "Appearance Image Validate Failed",
  117: "Deploy cvapp success",
  118: "Deploy cvapp failed",
  119: "Forensic Search",
  120: "Enable Search Failed",
  121: "Disable Search Failed",
  122: "Resume Search Failed"
};

export const eventAlerts = [notificationTypes[16], notificationTypes[17]];

export const bannerTypes = ["critical", "warning", "info", "success"];

export const getNotificationsList = (notificationInfo) => {
  const { data } = notificationInfo;
  return [
    {
      type: notificationTypes[0],
      title: notificationInfo?.title ?? "[camera] in [site] is offline.",
      subtitle: notificationInfo?.subtitle ?? "While offline, the camera cannot provide video or run apps.",
      buttonLabel: notificationInfo?.buttonLabel ?? "View camera details",
      redirectUrl: `/cameraInfoPage?cameraId=${notificationInfo?.data?.[0]?.id}`,
      persistent: notificationInfo?.persistent ?? false,
      closeOnButtonClick: true, // Add this to close notification when button is clicked
      state: {
        data: notificationInfo?.data,
        fields: notificationInfo?.fields || "",
        title: notificationInfo?.title
      }
    },
    {
      type: notificationTypes[1],
      title: "[companion] in [site] is offline.",
      subtitle: "While offline, no cameras paired to this companion device are able to run apps.",
      buttonLabel: "View companion details",
      redirectUrl: "/companionDeviceInfoPage",
      state: {
        data: notificationInfo?.data,
        fields: notificationInfo?.fields,
        title: notificationInfo?.title
      }
    },
    {
      type: notificationTypes[2],
      title: "Companion device at compute limit.",
      subtitle: "[companion] in [site] is at maximum GPU usage.  No more cameras can be added to this companion device until utilization is decreased.",
      buttonLabel: "View companion details",
      redirectUrl: "/companionDeviceInfoPage",
      state: {
        data: notificationInfo?.data,
        fields: notificationInfo?.fields,
        title: notificationInfo?.title
      },
      extraRedirectUrl: "/",
      extraButtonLabel: "View user guide"
    },
    {
      type: notificationTypes[4],
      title: "Streams being compressed due to bandwidth limitation",
      subtitle: "Streams are being compressed to [count]."
    },
    {
      type: notificationTypes[5],
      title: "Duplicate UUID",
      subtitle: "Multiple cameras are reporting the same UUID. Please check your system for possible security breaches.",
      buttonLabel: "View user guide",
      redirectUrl: "/"
    },
    {
      type: notificationTypes[6],
      title: "App unavailable",
      subtitle: "This [application] is unavailable for [count] devices.",
      buttonLabel: "Contact support",
      redirectUrl: "/support"
    },
    {
      type: notificationTypes[7],
      title: "No permission",
      subtitle: "You do not have the required access for this task. Please view your permissions on the Users page or talk with your system administrator.",
      buttonLabel: "View Users",
      redirectUrl: "/userdetails"
    },
    {
      type: notificationTypes[8],
      title: "Evidence deletion warning",
      subtitle: "Video evidence of event [event] will be deleted in 7 days. Please download video locally to save footage.",
      buttonLabel: "View event",

      redirectUrl: `/eventsInfo?eventid=${notificationInfo?.id}`
    },
    {
      type: notificationTypes[9],
      title: "Inactivity on live feed stream",
      subtitle: "Still there? Click okay.",
      buttonLabel: "Ok",
      redirectUrl: "/"
    },
    {
      type: notificationTypes[10],
      title: "License expiration warning",
      subtitle: "License [license] is going to auto-renew in 30 days, to manage your subscription please contact your rep."
    },
    {
      type: notificationTypes[11],
      title: "License overuse",
      subtitle:
        "Your team currently has more licenses being used than paid for. If you do not wish to have your access interrupted or to be charged for these additional licenses, please review your active licenses.",
      buttonLabel: "Manage licenses",
      redirectUrl: "/licenses"
    },
    {
      type: notificationTypes[16],
      title: notificationInfo?.title,
      subtitle: "",
      buttonLabel: "Go to event",
      redirectUrl: `/eventsInfo?eventid=${notificationInfo?.id}`,

      extraRedirectUrl: "",
      extraButtonLabel: "View later"
    },
    {
      type: notificationTypes[17],
      title: "events alert",
      subtitle: "There are [count] unresolved critical events taking place across your sites.",
      buttonLabel: "View events list",
      redirectUrl: "",
      state: {}
    },
    {
      type: notificationTypes[18],
      title: "User(s) added to group",
      subtitle: `${data?.subTitle}`,
      buttonLabel: "",
      redirectUrl: "/usergroupsdetails"
    },
    {
      type: notificationTypes[19],
      title: "User deleted from group",
      subtitle: `${data?.subTitle}`,
      buttonLabel: "",
      redirectUrl: "/usergroupsdetails"
    },
    {
      type: notificationTypes[20],
      title: "User group renamed",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroupsdetails"
    },
    {
      type: notificationTypes[21],
      title: "Delete User",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroups"
    },
    {
      type: notificationTypes[22],
      title: "Delete Usergroup",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroups"
    },
    {
      type: notificationTypes[23],
      title: "User details updated",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/userdetails"
    },
    {
      type: notificationTypes[24],
      title: "User group added",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroups"
    },
    {
      type: notificationTypes[25],
      title: "Invite sent",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroups"
    },
    {
      type: notificationTypes[26],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/cvAppSub"
    },
    {
      type: notificationTypes[27],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/devices"
    },
    {
      type: notificationTypes[28],
      title: "Failed to unpair camera",
      buttonLabel: ""
    },
    {
      type: notificationTypes[29],
      title: "Event resolved",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: `/eventsInfo?eventid=${notificationInfo?.id}`
    },
    {
      type: notificationTypes[30],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/devices"
    },
    {
      type: notificationTypes[31],
      title: "Camera pairing",
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[32],
      title: "Delete Camera",
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[33],
      title: `${data?.title} `
    },
    {
      type: notificationTypes[34],
      title: `${data?.title} `
    },
    {
      type: notificationTypes[35],
      title: "Document download failed!"
    },
    {
      type: notificationTypes[36],
      title: "Event not resolved",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: `/eventsInfo?eventid=${notificationInfo?.id}`
    },
    {
      type: notificationTypes[37],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.SNAPSHOT_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[38],
      title: "Campus deleted successfully!",
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[39],
      title: "Campus added successfully!",
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[40],
      title: "Site added successfully!",
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[41],
      title: `${data?.title} `
    },
    {
      type: notificationTypes[42],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[43],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[44],
      title: "No permission to view live feed",
      subtitle:
        "You do not have the required access to watch live feed. Please view your permissions on the Users page or talk with your system administrator.",
      buttonLabel: "View Users",
      redirectUrl: "/userdetails"
    },
    {
      type: notificationTypes[45],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[46],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[47],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[48],
      title: "Camera access credential error",
      subtitle:
        "Some cameras on your site do not use the same access credentials input for cameras on this companion device, which means they cannot be used for 5G Video Insights. Please check in your camera system that all cameras have the same credentials.",
      buttonLabel: ""
    },
    {
      type: notificationTypes[49],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[50],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[51],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[52],
      title: `${notificationInfo?.title}`
    },
    {
      type: notificationTypes[53],
      title: "Site updated successfully!",
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[54],
      title: NOTIFICATION_MESSAGES.CAMPUS_UPDATE_SUCCESS,
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[55],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.ALERT_CREATE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[56],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.ALERT_UPDATE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[57],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.ALERT_DELETE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[58],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.CALIBRATION_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[59],
      title: "User role successfully updated!",
      subtitle: "Note: The new permissions applied will reflect only after the user(s) relogin"
    },
    {
      type: notificationTypes[60],
      title: notificationInfo?.title,
      subtitle: notificationInfo?.subtitle,
      state: {
        data: notificationInfo?.data,
        fields: notificationInfo?.fields || "",
        title: notificationInfo?.title
      }
    },
    {
      type: notificationTypes[61],
      title: notificationInfo?.title,
      subtitle: notificationInfo?.subtitle,
      state: {
        data: notificationInfo?.data,
        fields: notificationInfo?.fields || "",
        title: notificationInfo?.title
      }
    },
    {
      type: notificationTypes[62],
      title: "Image and Video evidence is being processed… One moment, Please!"
      //subtitle: "This may take a moment. Please check back later",
    },
    {
      type: notificationTypes[63],
      title: "Video evidence is being processed… One moment, Please!"
    },
    {
      type: notificationTypes[64],
      title: "Processing event video",
      subtitle: "This may take a moment. Please check back later"
    },
    {
      type: notificationTypes[65],
      title: `Max. amount of streams for ${data?.name} `,
      subtitle: "Please close some of your live stream sessions",
      buttonLabel: ""
    },
    {
      type: notificationTypes[66],
      title: notificationInfo?.title,
      subtitle: notificationInfo?.subtitle
    },
    {
      type: notificationTypes[67],
      title: notificationInfo?.title
    },
    {
      type: notificationTypes[68],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[69],
      title: notificationInfo?.title,
      subtitle: notificationInfo?.subtitle
    },
    {
      type: notificationTypes[70],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[71],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[72],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[73],
      title: `${data?.title}`,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[74],
      title: `${data?.title}`,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[75],
      title: `${data?.title}`,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[76],
      title: notificationInfo?.title,
      subtitle: notificationInfo?.subtitle
    },
    {
      type: notificationTypes[77],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.EVENT_FETCH_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[78],
      title: `${data?.title}`,
      subtitle: `${data?.subTitle}`
    },
    {
      type: notificationTypes[79],
      title: `${data?.title}`
    },
    {
      type: notificationTypes[80],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.CAMERA_UPDATE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[81],
      title: "Account cancelled",
      subtitle:
        "Your account has been successfully cancelled. We're sorry to see you go. If you change your mind and wish to resubscribe, please contact your sales representative."
    },
    {
      type: notificationTypes[82],
      title: `${data?.ccdName} is updating to the latest firmware.`
    },
    {
      type: notificationTypes[83],
      title: "Invite not sent",
      subtitle: `${data?.subTitle} `
    },
    {
      type: notificationTypes[84],
      title: "Invite not deleted",
      subtitle: `${data?.subTitle} `
    },
    {
      type: notificationTypes[85],
      title: `${data?.subTitle} `,
      subtitle: ""
    },
    {
      type: notificationTypes[86],
      title: "Updated invite sent",
      subtitle: `${data?.subTitle} `
    },
    {
      type: notificationTypes[87],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.ROI_EDIT_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[88],
      title: "User details not updated",
      subtitle: `${data?.subTitle} `
    },
    {
      type: notificationTypes[89],
      title: data?.title,
      subtitle: data?.subtitle,
      buttonLabel: data?.buttonLabel,
      redirectUrl: data?.redirectUrl
    },
    {
      type: notificationTypes[90],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.SUSPEND_LICENSE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[91],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.RESUME_LICENSE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[92],
      title: NOTIFICATION_MESSAGES.LICENSE_LIMIT_EXCEEDED,
      subtitle: NOTIFICATION_MESSAGES.NO_LICENSE_AVAILABLE
    },
    {
      type: notificationTypes[93],
      title: data?.title || NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.CHANGE_LICENSE_FAILED
    },
    {
      type: notificationTypes[94],
      title: "License Assignment Successful",
      subtitle: "License has been successfully assigned to the device."
    },
    {
      type: notificationTypes[95],
      title: "License Assignment Failed",
      subtitle: "Error while assigning license to the device. Please try again."
    },
    {
      type: notificationTypes[96],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: `${data?.subTitle || NOTIFICATION_MESSAGES.FETCH_NOTIFICATION_GROUPS_FAIL_SUBTITLE}`
    },
    {
      type: notificationTypes[97],
      title: data?.title,
      subtitle: data?.subTitle
    },
    {
      type: notificationTypes[98],
      title: data?.title,
      subtitle: data?.subTitle
    },
    {
      type: notificationTypes[99],
      title: data?.title,
      subtitle: data?.subTitle
    },
    {
      type: notificationTypes[100],
      title: "Offline CCD Detected",
      subtitle: `${data?.subTitle || NOTIFICATION_MESSAGES.FETCH_NOTIFICATION_GROUPS_FAIL_SUBTITLE}`
    },
    {
      type: notificationTypes[101],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[102],
      title: `${data?.title} `,
      subtitle: `${data?.subTitle} `,
      buttonLabel: ""
    },
    {
      type: notificationTypes[103],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.AREA_NAME_EMPTY_SUBTITLE
    },
    {
      type: notificationTypes[104],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.SUBAREA_NAME_EMPTY_SUBTITLE
    },
    {
      type: notificationTypes[105],
      title: "Invite failed",
      subtitle: `${data?.subTitle} `,
      buttonLabel: "",
      redirectUrl: "/usergroups"
    },
    {
      type: notificationTypes[106],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[107],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[108],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[109],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: notificationInfo?.subTitle
    },
    {
      type: notificationTypes[110],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.USERS_LOAD_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[111],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: NOTIFICATION_MESSAGES.REFETCH_SNAPSHOT_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[112],
      title: "Image deleted successfully",
      subtitle: ""
    },
    {
      type: notificationTypes[113],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: "Image delete failed. Please try again."
    },
    {
      type: notificationTypes[114],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: "Image upload failed. Please try again."
    },
    {
      type: notificationTypes[115],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: "Failed to create appearance. Please try again."
    },
    {
      type: notificationTypes[116],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: "Failed to validate. Please try again later."
    },
    {
      type: notificationTypes[117],
      title: data?.title,
      subtitle: data?.subTitle
    },
    {
      type: notificationTypes[118],
      title: data?.title,
      subtitle: data?.subTitle
    },
    {
      type: notificationTypes[119],
      title: NOTIFICATION_MESSAGES.ERROR_TITLE,
      subtitle: data?.subTitle || NOTIFICATION_MESSAGES.SEARCH_CREATE_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[120],
      title: notificationTypes[120],
      subtitle: NOTIFICATION_MESSAGES.ENABLE_SEARCH_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[121],
      title: notificationTypes[121],
      subtitle: NOTIFICATION_MESSAGES.DISABLE_SEARCH_FAIL_SUBTITLE
    },
    {
      type: notificationTypes[122],
      title: notificationTypes[122],
      subtitle: NOTIFICATION_MESSAGES.RESUME_SEARCH_FAIL_SUBTITLE
    }
  ];
};
